<template>
  <div class="modal-wrapper">
    <BasicModal
      :title="'用語の説明'"
      :isShowModal=isShowModal
      :canCancel="true"
      @cancel="cancel">
      <div class="accordion-container">
        <div class="top-description">
          <p></p>
        </div>
        <section class="accordion-wrapper disp-scroll">
          <b-collapse
            class="card"
            animation="slide"
            v-for="(collapse, index) of collapses"
            :key="index"
            :open="isOpen == index"
            @open="isOpen = index">
            <div
              slot="trigger"
              slot-scope="props"
              class="card-header"
              role="button">
              <p class="card-header-title">
                {{ collapse.title }}
              </p>
              <a class="card-header-icon">
                <b-icon
                  :icon="props.open ? 'menu-down' : 'menu-up'">
                </b-icon>
              </a>
            </div>
            <div class="card-content">
              <div class="content">
                {{ collapse.text }}
              </div>
            </div>
          </b-collapse>
        </section>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
export default {
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isOpen: -1,
      collapses: [
        {
          title: '自社動機付け',
          text: '滞在時間が5分を超える場合。もしくはHRモンスター独自に収集している求人サイト閲覧履歴がある場合。'
        },
        {
          title: '有望フラグ',
          text: '直近1ヶ月の訪問回数が3回を超える場合。'
        }
      ]
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-wrapper {
  .accordion-container {
    padding: 16px;
  }
  .accordion-wrapper {
    height: 480px;
    padding: 8px;
  }
  .top-description {
    margin-bottom: 16px;
    text-align: left;
    font-size: 14px;
  }
  .card-header-title {
    font-size: 12px;
  }
  .card-content {
    .content {
      text-align: left;
      font-size: 12px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/modals/ModalHowToScout.vue